<title mat-dialog-title>{{ 'cameras.aiGrid.title' | t }}</title>
<mat-dialog-content>
  <div class="outsideWrapper">
    <div class="insideWrapper">
      <sn-audit-camera-stream-view
        class="subStream"
        [camera]="data"
        [autoplay]="true"
        [controls]="false"
        [timestamp]="false"
        [actions]="false"
        (stateChange)="onStateChange($event)"
      >
      </sn-audit-camera-stream-view>
      <svg
        id="aiGridCanvas"
        xmlns="http://www.w3.org/2000/svg"
        class="coveringCanvas"
        [attr.height]="svgHeight"
        [attr.width]="svgWidth"
        (mouseup)="handleMouseUp($event)"
        (mousemove)="handleMouseMove($event)"
      >
        <defs>
          <pattern
            *ngIf="gridX && gridY"
            id="grid"
            [attr.width]="gridX"
            [attr.height]="gridY"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" stroke-width="1" />
          </pattern>
        </defs>
        <rect id="gridRect" width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" type="button" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button [disabled]="!currentRoi" color="warn" (click)="deleteRegion()">
    {{ 'cameras.aiGrid.deleteRegion' | t }}
  </button>
  <button mat-button [disabled]="!drawing && !isPolygonComplete" color="warning" (click)="reset()">
    {{ 'common.reset' | t }}
  </button>
  <button
    mat-button
    color="success"
    type="submit"
    (click)="submit()"
    [disabled]="!isPolygonComplete"
    [mtBasicSpinner]="isLoading"
  >
    {{ 'common.save' | t }}
  </button>
</mat-dialog-actions>
